import { IAppState } from 'shared/common/state';

export function selectNewbuildingBrokerSelfRequestFormWidgetLoading(state: IAppState) {
  return state.newbuildingBrokerSelfRequestFormWidget.loading;
}
